import { render, staticRenderFns } from "./InformationForm.vue?vue&type=template&id=74f38548&scoped=true"
import script from "./InformationForm.vue?vue&type=script&lang=js"
export * from "./InformationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f38548",
  null
  
)

export default component.exports